var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{ref:"video-button",staticClass:"video-button",staticStyle:{"opacity":"0","transform":"translateY(10em)"}},[_vm._v("WATCH VIDEO")])}
var staticRenderFns = []

export { render, staticRenderFns }